import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { reviews } from '../mock';

const Reviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % reviews.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isPaused]);

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % reviews.length);
  };

  return (
    <section
      id="reviews"
      className="py-20 px-4"
      style={{ background: 'var(--bg-section)' }}
    >
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="heading-2 mb-4">What Our Clients Say</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Real feedback from businesses we've helped grow online
          </p>
        </div>

        {/* Carousel */}
        <div
          className="relative"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div className="bg-[var(--bg-card)] border border-[var(--border-light)] rounded-xl p-8 md:p-12 shadow-sm">
            <div className="flex flex-col items-center text-center">
              {/* Customer Image */}
              <img
                src={reviews[currentIndex].image}
                alt={reviews[currentIndex].name}
                className="w-20 h-20 rounded-full object-cover mb-4 border-2 border-[var(--accent-primary)]"
              />

              {/* Rating Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(reviews[currentIndex].rating)].map((_, i) => (
                  <Star
                    key={i}
                    size={20}
                    fill="var(--accent-primary)"
                    stroke="var(--accent-primary)"
                  />
                ))}
              </div>

              {/* Review Text */}
              <p className="body-large mb-6 max-w-2xl" style={{ color: 'var(--text-body)' }}>
                "{reviews[currentIndex].review}"
              </p>

              {/* Customer Name */}
              <p className="heading-3">{reviews[currentIndex].name}</p>
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={goToPrevious}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 w-10 h-10 rounded-full bg-white border border-[var(--border-light)] flex items-center justify-center hover:bg-[var(--accent-wash)] transition-all duration-200"
            aria-label="Previous review"
          >
            <ChevronLeft size={20} style={{ color: 'var(--text-primary)' }} />
          </button>
          <button
            onClick={goToNext}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 w-10 h-10 rounded-full bg-white border border-[var(--border-light)] flex items-center justify-center hover:bg-[var(--accent-wash)] transition-all duration-200"
            aria-label="Next review"
          >
            <ChevronRight size={20} style={{ color: 'var(--text-primary)' }} />
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-6">
            {reviews.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-200 ${
                  index === currentIndex
                    ? 'w-8 bg-[var(--accent-primary)]'
                    : 'bg-[var(--border-medium)]'
                }`}
                aria-label={`Go to review ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
